import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Route, Switch} from 'react-router-dom'
import DriverRequestList from './DriverRequestList'
import DriverList from './DriverList'
import DriverForm from './DriverForm'
import DriverFamiliesList from './DriverFamiliesList'
import DriverPaymentList from './DriverPaymentList'

class Maetoristas extends PureComponent {
  render() {
    return (
      <Switch>
        <Route path="/maetoristas" exact component={DriverList} />
        <Route path="/maetoristas/adicionar" exact component={DriverForm} />
        <Route path="/maetoristas/solicitacoes" exact component={DriverRequestList} />
        <Route path="/maetoristas/:id/editar" exact component={DriverForm} />
        <Route path="/maetoristas/:id/familias" exact component={DriverFamiliesList} />
        <Route path="/maetoristas/:id/pagamentos" exact component={DriverPaymentList} />
      </Switch>
    )
  }
}

Maetoristas.propTypes = {
  //label: PropTypes.string,
};

const styles = {};

export default Maetoristas;



// WEBPACK FOOTER //
// ./src/screens/driver/Drivers.js